var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 823.67 597",
    id: "NewMessages",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 184.47,
    x2: 188.3,
    y1: 186.62,
    y2: 176.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#00082e",
    className: "stopColor00272e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#3f4fa1",
    stopOpacity: 0.25,
    className: "stopColor3f80a1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697eeb",
    stopOpacity: 0,
    className: "stopColor69b9eb svgShape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 343.3,
    x2: 455.64,
    y1: 346.98,
    y2: 41.5,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 393.2,
    x2: 383.08,
    y1: 139.61,
    y2: 633.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68fdbf",
    className: "stopColor68e1fd svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#67f9bc",
    className: "stopColor67ddf9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#52cc99",
    className: "stopColor5cb3ce svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#767fad",
    className: "stopColor538ea9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#4c568b",
    className: "stopColor4c718b svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#464d73",
    className: "stopColor465a73 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#424763",
    className: "stopColor424a63 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#404459",
    className: "stopColor404059 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3d4156",
    className: "stopColor3f3d56 svgShape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 393.88,
    x2: 383.76,
    y1: 139.62,
    y2: 633.98,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 397.21,
    x2: 387.09,
    y1: 139.69,
    y2: 634.05,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 683.35,
    x2: 704.34,
    y1: 150.83,
    y2: 150.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6699",
    className: "stopColorecc4d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#efe2d1",
    className: "stopColorefd4d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffbf66",
    className: "stopColorf2eac9 svgShape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 694.47,
    x2: 690.14,
    y1: 139.15,
    y2: 187.7,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 664.6,
    x2: 709.11,
    y1: 121.91,
    y2: 121.91,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 764.44,
    x2: 824,
    y1: 85.12,
    y2: 85.12,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 810.3,
    x2: 804.28,
    y1: 78.07,
    y2: 31.33,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 30.23,
    x2: 89.78,
    y1: -160.53,
    y2: -160.53,
    gradientTransform: "scale(-1 1) rotate(-32 72.11 1144.583)",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 76.08,
    x2: 70.06,
    y1: -167.26,
    y2: -214,
    gradientTransform: "scale(-1 1) rotate(-32 72.11 1144.583)",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 533.17,
    x2: 540.88,
    y1: 470.11,
    y2: 502.23,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 723.21,
    x2: 736.06,
    y1: 491.76,
    y2: 509.74,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 770.23,
    x2: 694.43,
    y1: 222.33,
    y2: 178.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0d6efd",
    d: "M131.3 125c-24.34 5.16-49.64 10.76-69.18 26.17-16.5 13-42.21 37-50 56.5-33 82.37 4.31 182.6 76.73 233.86 34.06 24.11 76.51 35.78 107.12 64.16 19.36 17.95 32.92 41.71 53.52 58.21 30.1 24.09 70.74 29.42 109.2 32 26.72 1.81 54.48 2.59 79.27-7.57 17.92-7.34 33.1-19.93 48-32.34l98.71-82.43c15.86-13.23 30.69-34.3 51.34-34.16 185.86 1.33 198.39-217.4-86.86-314.28-25.14-8.54-42.38-32.28-66-44.45-48.79-25.15-104.94-17-154.15.4-62.48 22.15-132.86 30.14-197.7 43.93Z",
    opacity: 0.18,
    className: "color68e1fd svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff8066",
    d: "M779.07 477.86c7.78.13 17.8 2.07 19 9.75.65 4-1.64 7.89-4.12 11.12-15.51 20.27-41.21 30.52-66.57 33.27s-50.92-1.1-76.24-4.22q-54.88-6.78-110.2-9c-26.22-1.06-53.8-1.72-76.38-15.08-4.19-2.47-8.31-5.56-10.32-10-4-8.83 2.32-19.58 11-23.87s18.88-3.87 28.56-3.35c95.06 5.12 190.05 11.38 285.27 11.38Z",
    opacity: 0.05,
    className: "color000405 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d6efd",
    d: "M779.4 126.4s-33.83 43.75-40.25 51.08c-11.71 13.32-19.26 30.79-19.26 30.79l-17 72.34-19-5.07-41.31-11S657.26 225 650.15 213c-9.48-16-1.28-26 .88-32.87 4-12.73-16.43-36-16.43-36L621.51 85.5l19.76-2.64 14.34 47.53 24.57 21.93 17.5.93s13.2 2.72 22.8-1.72c9.18-4.26 41.61-40.83 41.61-40.83l13.23 12ZM617.33 200.59v260.56A24.86 24.86 0 0 1 592.46 486H202.77a24.86 24.86 0 0 1-24.86-24.87V200.59a24.85 24.85 0 0 1 24.86-24.87h389.69a24.87 24.87 0 0 1 24.87 24.87Z",
    className: "color68e1fd svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d6efd",
    d: "M610.59 183.67H183.98l3.46-2.65a6.12 6.12 0 0 1 .5-.39L390.88 25.07l6.41-4.91 206.47 158.28Z",
    className: "color68e1fd svgShape"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d6efd",
    d: "m617.33 200.59-5.19 3.75-37.79 27.37L390.88 364.6 214.43 228.71l-36.52-28.12.47-4.83a24.69 24.69 0 0 1 6.18-12.09 23.32 23.32 0 0 1 2.88-2.65 6.12 6.12 0 0 1 .5-.39 24.74 24.74 0 0 1 14.83-4.91h389.69a24.88 24.88 0 0 1 24.75 22.47 23.81 23.81 0 0 1 .12 2.4Z",
    className: "color68e1fd svgShape"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M187.77 181a25 25 0 0 0-2.88 2.65h-.58Z",
    opacity: 0.61,
    transform: "translate(-.33)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "m617.66 200.59-5.19 3.76-37.79 27.36L391.21 364.6 214.76 228.72l-36.52-28.13.47-4.82a24.73 24.73 0 0 1 6.18-12.1 25 25 0 0 1 2.88-2.65l.5-.38L391.21 25.07l6.41-4.91 206.47 158.28a24.83 24.83 0 0 1 13.45 19.76 23.61 23.61 0 0 1 .12 2.39Z",
    opacity: 0.61,
    transform: "translate(-.33)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M574.35 181.34v50.38l-67.71 49L491.11 292l-100.23 72.6-94.27-72.6-14.59-11.24-67.59-52v-47.42a14.77 14.77 0 0 1 14.77-14.77h330.39a14.77 14.77 0 0 1 14.76 14.77Z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M525.06 225.51h-267a5.62 5.62 0 0 1-5.62-5.62 5.62 5.62 0 0 1 5.62-5.62h267a5.62 5.62 0 0 1 5.62 5.62 5.62 5.62 0 0 1-5.62 5.62Z",
    transform: "translate(-.33)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M525.06 258.76h-267a5.62 5.62 0 0 1-5.62-5.62 5.62 5.62 0 0 1 5.62-5.62h267a5.62 5.62 0 0 1 5.62 5.62 5.62 5.62 0 0 1-5.62 5.62Z",
    transform: "translate(-.33)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    style: {
      isolation: "isolate"
    },
    d: "M506.64 280.76 491.11 292h-194.5l-14.6-11.24h224.63z"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff8066",
    d: "M390.88 364.6 228.02 486.02H557.1L390.88 364.6z",
    opacity: 0.05,
    className: "color000405 svgShape"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d6efd",
    d: "M250.4 90.2c-8.2-17.59-39-14.7-39-14.7 19-11.21 15.36-39.68 15.13-41.36 8.31 24.82 37 19.34 39.57 18.8-19.05 4.7-15.7 37.26-15.7 37.26ZM197 126.29c-5.21-11.18-24.8-9.34-24.8-9.34 12.4-7.37 9.59-26.34 9.59-26.34v.11c5.32 15.69 23.52 12.21 25.14 11.87-12.06 3-9.93 23.7-9.93 23.7Z",
    className: "color68e1fd svgShape"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d4156",
    d: "M721.56 92.7a12.36 12.36 0 0 1 8.56-2.7 9 9 0 0 1 6.2 2.14 9.88 9.88 0 0 1 2.42 5.33 30.59 30.59 0 0 1 .55 7.46c-.22 4.59-1.41 9.45.57 13.6a9.73 9.73 0 0 0 1.88 2.66 5.23 5.23 0 0 0 3.48 1.73 2.79 2.79 0 0 0 2.86-2.24 10.62 10.62 0 0 1-16.36 3.91l1.74 3.53a20.27 20.27 0 0 1-4.16-1.58c-4.25-2.31-6.63-7-7.76-11.74-1-4.35-1.2-8.84-2.14-13.21-.73-3.35-.55-6.47 2.16-8.89Z",
    className: "color3f3d56 svgShape"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d6efd",
    d: "M720.28 97.5a7 7 0 0 1 2.54.39 4 4 0 0 1 2.45 3.35 3.78 3.78 0 0 1-2.08 3.57 6.34 6.34 0 0 1-2.7.47c-.84 0-1.69 0-2.53-.08a1.47 1.47 0 0 1-.69-.17 1.52 1.52 0 0 1-.47-.67 15.11 15.11 0 0 1-1.23-3.43c-.69-3.68 1.79-3.46 4.71-3.43Z",
    className: "color68e1fd svgShape"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M704.34 132.61s-.16 2.89-.36 6.65c-.17 3.17-.38 7-.55 10.18a21.39 21.39 0 0 1-6.47 14.2c-2.26 2.31-7.65 6.62-11.76 5.09-2-.74-2.07-3.26-1.65-4.77a29.62 29.62 0 0 0 1.53-8.53 29.93 29.93 0 0 0-.63-7c-2.58-6.43 19.89-15.82 19.89-15.82Z",
    transform: "translate(-.33)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M704.34 132.61s-.16 2.89-.36 6.65c-1.58 3.52-3.06 6.39-3.87 7.82-1.63 2.89-8.33 7.44-15 8.35a29.93 29.93 0 0 0-.63-7c-2.61-6.43 19.86-15.82 19.86-15.82Z",
    transform: "translate(-.33)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M684.77 94.32a21.49 21.49 0 0 0-20 24.27 72.68 72.68 0 0 0 6.62 25.22c7 12 24.74 2.13 27.55-2.81s13.59-27.22 9.06-33.53c-3.12-4.26-11.77-13.61-23.23-13.15Z",
    transform: "translate(-.33)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d4156",
    d: "M678.14 82.13a37.22 37.22 0 0 1 22.94.67c7.27 2.76 13.54 8.44 16.31 15.71a28.57 28.57 0 0 1-.64 20.7 40.44 40.44 0 0 1-13 16.43c-1.47-4.5 3.06-8.5 4.82-12.89a3.63 3.63 0 0 0 .25-2.62c-.64-1.63-3.08-1.81-4.47-.75s-2 2.85-2.51 4.52c1.35-7.15 2.35-15.55-2.71-20.79-3-3.1-7.53-4.26-11.85-4.3a29 29 0 0 0-21.19 9.11c-1.59 1.71-3.85 3.81-5.87 2.63a4 4 0 0 1-1.42-1.73c-5.97-11.82 9.71-24.05 19.34-26.69Z",
    className: "color3f3d56 svgShape"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d4156",
    d: "M687.8 95.34c-5-2.2-10.25-4-15.68-4s-11.06 1.84-14.65 5.92a20.57 20.57 0 0 0-4 7.77 14 14 0 0 0-.7 5.54 23.88 23.88 0 0 0 1 4c.94 3.24 1.34 7-.71 9.72a4.38 4.38 0 0 1-3.34 1.86 2.72 2.72 0 0 1-2.74-2.33c-.88 2.49.56 5.41 2.85 6.72a9.36 9.36 0 0 0 7.67.37 8.31 8.31 0 0 0 2.83-1.55 9.74 9.74 0 0 0 2-2.75c2.09-3.79 3.14-8 4.7-12.09s3.82-8 7.51-10.3a19.4 19.4 0 0 1 9.54-2.37c3.31-.11 6.64.16 9.94-.14s.91-2.26-.51-3.29a31.53 31.53 0 0 0-5.71-3.08Z",
    className: "color3f3d56 svgShape"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M822.44 59.49c.85.66-7.11 6.86-7.11 6.86s-3.72 6.41-7.5 8.19-32.18 48.15-32.18 48.15l-11.21-10.16L788.62 80s8-15.33 7.11-22c0 0 .48-7.88 2.89-4.22 1.7 2.61.61 6.72 2.62 7.16a1.09 1.09 0 0 0 .64-.14 22.63 22.63 0 0 0 4.55-3.64c4-3.81 8.78-9.11 8.78-9.11s2.62-1.11 2.29 0-5.14 8.6-5.41 9c.45-.41 7.83-7 9-6.49s-5.72 8.1-6.12 8.54c.43-.3 8.3-5.78 8.89-5.29 1.11.93-6 7.1-6.59 7.57.45-.24 4.36-2.53 5.17-1.89Z",
    transform: "translate(-.33)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M814 64.24a4 4 0 0 1-1.85.15 51 51 0 0 0-6.06-.1c-1.36.06-4.17 1-4.24-1.11 0-.56.14-1.11.11-1.67 0-.24-.06-.48-.1-.72a22.63 22.63 0 0 0 4.55-3.64 6.63 6.63 0 0 1 1.72.87q2 1.29 3.94 2.55c.7.46 1.4.92 2.07 1.42a1.8 1.8 0 0 1 .68.77 1.29 1.29 0 0 1-.82 1.48Z",
    transform: "translate(-.33)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M618.73 7.42c-1.08.12 2.42 9.58 2.42 9.58s-.22 7.41 2.05 10.91 1.95 57.15 1.95 57.15l14.88-2-3.38-40.41s1.29-17.24 5.56-22.43c0 0 3.74-6.95-.23-5.11-2.82 1.32-4.07 5.38-6 4.7a1.06 1.06 0 0 1-.47-.46 22 22 0 0 1-2-5.49c-1.41-5.35-2.65-12.37-2.65-12.37S629.26-.81 629 .3s-.17 10-.16 10.51c-.17-.57-2.95-10.09-4.25-10.26s.59 9.9.71 10.48c-.22-.48-4-9.28-4.78-9.18-1.43.21 1.41 9.23 1.62 9.9-.28-.44-2.39-4.43-3.41-4.33Z",
    transform: "translate(-.33)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M623.37 15.91a4 4 0 0 0 1.49 1.09 50.74 50.74 0 0 1 5.2 3.12c1.13.77 3 3.07 4.19 1.29.32-.46.47-1 .79-1.47a6.47 6.47 0 0 1 .47-.57 22 22 0 0 1-2-5.49 6.49 6.49 0 0 0-1.92-.16l-4.69.09c-.84 0-1.68 0-2.52.11a1.79 1.79 0 0 0-1 .3 1.29 1.29 0 0 0-.01 1.69Z",
    transform: "translate(-.33)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M566 479.21c-4 8.17-6.91 14.52-6.91 14.52l-50.33 2.4s8.34-22.07 21.91-16.37c4.59 1.92 21.22-1.69 21.22-1.69l.52-1.67Z",
    transform: "translate(-.33)",
    style: {
      isolation: "isolate"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d4156",
    d: "m744.05 481.68-7.71 4.32-66-69.38-7.28-92.62-60.18 54.59s1.61 37.59-19.43 67c-3.77 5.27-11.44 20.58-17.24 32.54-.18.37-.36.75-.53 1.12l-1.13-.23-3.93-.82-8.53-1.76 27.66-111.8 62.85-100.06 41.31 11 19 5.07s12.82 25.69 0 92.18l-8.5 38.06s34.26 18.27 44.82 54.41l4.81 16.36Z",
    className: "color3f3d56 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "m744.38 481.68 7.83 8.19-19.87 20.72h-26s5.54-9.15 16.62-10.6 13.73-14 13.73-14Z",
    transform: "translate(-.33)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m216.14 74.06-4.39 1.44c19-11.21 15.36-39.68 15.13-41.36.3 1.35 4.72 20.14 2.31 26.31-3.01 7.71-13.05 13.61-13.05 13.61ZM184.74 108.44c-2.32 3.21-11.54 8.16-12.17 8.49 12.4-7.37 9.59-26.34 9.59-26.34v.11c.49 1.3 4.84 14.6 2.58 17.74Z",
    opacity: 0.22,
    transform: "translate(-.33)",
    style: {
      isolation: "isolate"
    },
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    opacity: 0.22,
    style: {
      isolation: "isolate"
    },
    d: "m178.65 214.27 203.67 156.71 8.56-6.38-212.97-164.01.74 13.68zM397.62 369.97l219.71-158.14v-10.79l-226.45 164 6.74 4.93z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m617.54 198.64-.6 1.68-4.47 4.47c3.14-5.42-5.73-18-5.73-18l-3.54-2.65-10.63-8L391.21 25.52l6.41-4.91 206.47 158.27a24.86 24.86 0 0 1 13.45 19.76Z",
    opacity: 0.22,
    transform: "translate(-.33)",
    style: {
      isolation: "isolate"
    },
    className: "colorffffff svgShape"
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M779.73 126.4s-33.83 43.75-40.25 51.08c-11.71 13.32-19.26 30.79-19.26 30.79l-17 72.34-19-5.07s17.74-66.33 24.87-80.41 66.54-72.44 66.54-72.44Z",
    opacity: 0.61,
    transform: "translate(-.33)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#23273a",
    d: "M744.04 481.66c-.35-1-11.64-32.36-28.59-45.51-17.21-13.36-27.21-31.8-27.21-31.8-4.05-35.4-4.33-128.81-4.33-128.81l19 5.07s12.82 25.69 0 92.18l-8.5 38.06s34.26 18.31 44.82 54.45ZM602.88 378.57s1.61 37.59-19.43 67c-3.77 5.27-11.44 20.58-17.24 32.54l-1.66.89-3.93-.82 32.62-102.89s39.51-46.81 46.74-51.29 23.08 0 23.08 0Z",
    className: "color25233a svgShape"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contact_us.ed77dd0dc3f70409f5ec7bdc010bd6f1.svg";
export { ForwardRef as ReactComponent };